export const englishNameToClass = {
  'Math Foundations':'pre-algebra',
  'Pre Algebra': 'pre-algebra',
  'Pre-Algebra': 'pre-algebra',
  'Algebra 1': 'algebra-1',
  'Algebra 2': 'algebra-2',
  'Calculus': 'calculus',
  'Geometry': 'geometry',
  'Astronomy': 'astronomy',
  'Physics': 'physics',
  'Adv Biology': 'adv-biology',
  'Adv. Biology': 'adv-biology',
  'Advanced Biology': 'adv-biology',
  'Earth Science': 'earth-science',
  'Chemistry': 'chemistry',
  'Biology': 'biology',
  'Advanced Topics': 'advanced-topics'
}

export default {
  8951:'pre-algebra',
  4106: 'algebra-1',
  4712: 'algebra-2',
  1: 'calculus',
  752: 'geometry',
  1943: 'astronomy',
  1618: 'physics',
  7587: 'adv-biology',
  9213: 'earth-science',
  7954: 'chemistry',
  10005: 'biology',
  5525: 'advanced-topics',
  1617: 'math',
  8910: 'science',
}

export const IdToEnglishName = {
  8951:'Pre-Algebra',
  4106: 'Algebra 1',
  4712: 'Algebra 2',
  1: 'Calculus',
  752: 'Geometry',
  1943: 'Astronomy',
  1618: 'Physics',
  7587: 'Advanced Biology',
  9213: 'Earth Science',
  7954: 'Chemistry',
  10005: 'Biology',
  5525: 'Advanced Topics',
  1617: 'Math',
  8910: 'Science',
}



// WEBPACK FOOTER //
// ./src/core/less/SubjectToCSSName.js